<div class="container">
    <div class="row justify-content-end">
        <button
            class="filter-btn-toggler"
            nbButton
            status="control"
            shape="semi-round"
            size="small"
            (click)="openModal(content)"
        >
            {{ "GENERAL.FILTER" | translate }} <nb-icon icon="funnel-outline"></nb-icon>
        </button>
    </div>
</div>

<ng-template #content let-modal>
    <nb-card class="filter-modal">
        <nb-card-body>
            <div class="modal-header d-flex align-items-center px-0 mb-4">
                <span class="subtitle">{{ "GENERAL.FILTER" | translate }}</span>
                <button type="button" nbButton tabindex="-1" (click)="closeModal()">
                    <nb-icon icon="close-outline"></nb-icon>
                </button>
            </div>
            <div class="modal-body">
                <div class="filter-options" *ngFor="let filter of filterList; let index = index">
                    <div
                        class="filter-options-header"
                        [class.list-active]="!collapse[index]"
                        (click)="collapse[index] = !collapse[index]"
                    >
                        <div>
                            <fa-icon [icon]="icons.caretRight"></fa-icon>
                            <span>{{ getHeader(filter) }}</span>
                        </div>

                        <span class="badge">{{ getSelected(filter) }}</span>
                    </div>
                    <div class="filter-options-list" [ngbCollapse]="collapse[index]">
                        <!-- prettier-ignore -->
                        <div
                    [ngClass]="['filter-option', filter[getKey(filter)].type === 1 ? 'radio' : 'checkbox']"
                    *ngFor="let option of getOptionsByUnkownKey(filter); let index = index">
                    <input
                        [type]="filter[getKey(filter)].type === 1 ? 'radio' : 'checkbox'"
                        [attr.name]="'check-' + getKey(filter)"
                        [checked]="option.selected"
                        [id]="'check-' + getKey(filter) + index"
                        [value]="makeValue(option, filter)"
                        (change)="onChangeEvt($event)"
                    />
                    <!-- prettier-ignore -->
                    <label [for]="'check-' + getKey(filter) + index">
                        <span>{{ option.description }}</span>
                        <fa-icon [icon]="icons.check" *ngIf="filter[getKey(filter)].type === 2"></fa-icon>
                    </label>
                </div>
                    </div>
                </div>
            </div>
        </nb-card-body>
        <nb-card-footer>
            <button nbButton fullWidth (click)="onFilterBtnClick()" class="mt-4">
                {{ "GENERAL.FILTER-RESULT" | translate }}
            </button>
        </nb-card-footer>
    </nb-card>
</ng-template>
